import { connect } from 'react-redux';
import { flow, find, get } from 'lodash/fp';
import InstallationItemActionsBar from './InstallationItemActionsBar';
import setItemAttribute from '../../../../../../actions/setItemAttribute';

const mapStateToProps = ({ estimateBuilder }, { itemId }) => {
  const items = get('entities.items')(estimateBuilder);
  const item = get(`byId.${itemId}`)(items);

  const purchaseOption = flow(
    get('attributes'),
    find({ name: 'purchaseOption' }),
    get('value'),
  )(item);

  const hasProduct = !!get('itemProduct.configurationGuid')(item);

  return {
    purchaseOption,
    hasProduct,
  };
};

const mapDispatchToProps = (dispatch, { itemId }) => ({
  setPurchaseOption: value => dispatch(setItemAttribute(value, itemId, 'purchaseOption')),
});

export default connect(mapStateToProps, mapDispatchToProps)(InstallationItemActionsBar);
